
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M8.66 14.268a.76.76 0 01-.75 0l-3.928-2.215a.821.821 0 01-.41-.718V3.938a5.973 5.973 0 019.428 0v7.397c0 .3-.158.575-.41.718l-3.93 2.215zm-1.499 1.435a2.28 2.28 0 002.25 0l3.928-2.215a2.465 2.465 0 001.232-2.153V3.703a.984.984 0 00-.191-.585c-3.078-4.157-9.11-4.157-12.188 0A.984.984 0 002 3.703v7.632c0 .898.473 1.724 1.233 2.153l3.928 2.215zm2.072-10.15a3.764 3.764 0 00-.004.161V6.8h.628c.293 0 .561.166.697.43a.812.812 0 01-.052.827l-1.913 2.8a.779.779 0 01-.88.306c-.318-.101-.318-.503-.318-.845V9.2h-.677a.784.784 0 01-.697-.43.812.812 0 01.054-.829l1.924-2.8a.778.778 0 01.88-.304c.384.123.371.416.358.715z"}})])
          )
        }
      }
    